import React from "react";
import { Button } from "antd";
const defaultProps = {
  disabled: false,
  shape: "",
  size: "large",
  type: "primary"
};
class LoadingButton extends React.Component {
  state = {
    loading: false
  };

  enterLoading = (e) => {
    this.setState({ loading: true });
    this.props.onClick(e,() => {
      this.setState({ loading: false });
    });
  };

  render() {
    const { style, type, size, shape, disabled, className,dataClickDclog } = this.props;
    return (
      <Button
        loading={this.state.loading}
        onClick={this.enterLoading}
        size={size ? size : defaultProps.size}
        style={style ? style : {}}
        type={type ? type : defaultProps.type}
        shape={shape ? shape : defaultProps.shape}
        disabled={disabled ? disabled : defaultProps.disabled}
        className={className ? className : ""}
        data-click-dclog={dataClickDclog?dataClickDclog:''}
      >
        {this.props.children}
      </Button>
    );
  }
}
export default LoadingButton;
